import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConflictResponse, CrewConflictResponse } from '../models/conflict-response.model';

@Injectable()
export class ConflictCheckService {
  constructor(private readonly http: HttpClient) {}
  /* eslint-disable @typescript-eslint/no-explicit-any */

  checkConflicts(type: ConflictRequestType, payload: any): Observable<ConflictResponse[]> {
    const url = `/sdapi/pre-flight/conflicts/${type}`;
    return this.http.post<ConflictResponse[]>(url, payload);
  }

  checkAllScheduledFlightConflicts(payload: any): Observable<ConflictResponse[]> {
    const url = '/sdapi/pre-flight/conflicts/GetAllScheduledFlightConflicts';
    return this.http.post<ConflictResponse[]>(url, payload);
  }

  checkCrewConflicts(type: ConflictRequestType, payload: any): Observable<CrewConflictResponse[]> {
    const url = `/sdapi/pre-flight/conflicts/${type}`;
    return this.http.post<CrewConflictResponse[]>(url, payload);
  }

  /* eslint-enable @typescript-eslint/no-explicit-any */
}

export enum ConflictRequestType {
  ScheduledAircraftTrip = 'ScheduledAircraftTrip',
  // (scheduled) flight
  ScheduledAirport = 'ScheduledAirport',
  ScheduledAirportFbo = 'ScheduledAirportFbo',
  ScheduledFlightAircraft = 'ScheduledFlightAircraft',
  ScheduledFlightAircraftPerformance = 'ScheduledFlightAircraftPerformance',
  ScheduledFlightAirport = 'ScheduledFlightAirport',
  ScheduledFlightCrewMember = 'ScheduledFlightCrewMember',
  ScheduledFlightFuelType = 'ScheduledFlightFuelType',
  ScheduledFlightPassenger = 'ScheduledFlightPassenger',
  // crew
  ScheduledCrewCurrencyEvents = 'ScheduledCrewCurrencyEvents'
}
